import 'slick-carousel';
import { $win } from '../utils/globals'

const postSlider = () => {
	const $container = $('.js-slider-post');

	if ( ! $container.length ) {
		return;
	}
	
	let $postSlider = $container.find('.slider__slides');

	const settings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		dots: false,
		prevArrow: $('.slider__prev'),
		nextArrow: $('.slider__next'),
		autoplay: true,
		autoplaySpeed: 6000,
		pauseOnHover: false,
	}


	$win.on('load resize', function(){
		if ( $win.width() > 767 && ! $postSlider.hasClass('slick-initialized') ) {
			$postSlider.slick(settings);	
		} else if ( $postSlider.hasClass('slick-initialized') && $win.width() < 768 ) {
			$postSlider.slick('unslick');	
		}
	})
}

postSlider();
